import api from '../../../../helpers/api';

export const savePolygons = (payload) => {
  return api.post(`/developer/platform/polygon/polygons`, payload);
};

export const getPolygons = () => {
  return api.get(`/developer/platform/polygon/polygons`);
};

export const getOwnPolygons = () => {
  return api.get(`/developer/platform/polygon/polygons/owned`);
};

export const deletePolygons = (polygonId) => {
  return api.delete(`/developer/platform/polygon/polygons/${polygonId}`);
};

export const editPolygons = (polygonId, payload) => {
  return api.put(`/developer/platform/polygon/polygons/${polygonId}`, payload);
};
